<template>
  <div class="info-box">
    <el-form
      :model="state.model"
      label-width="auto"
      label-position="top"
      ref="formDom"
      size="large"
      class="flex-1 overflow-y-auto px-2.5"
    >
      <ul
        class="grid grid-cols-2 gap-x-3"
        style="grid-template-columns: 1fr 30%"
      >
        <el-form-item
          label="所属甲方"
          prop="customer_id"
          :rules="[
            { required: true, message: '请选择所属甲方', trigger: 'blur' },
          ]"
        >
          <el-select
            v-model="state.model.customer_id"
            placeholder="选择所属甲方"
          >
            <el-option
              v-for="item in state.jfdw_data"
              :key="item"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
            <template #footer>
              <el-button
                plain
                class="float-right mb-3"
                size="small"
                @click="onLoadJfdw"
              >
                刷新
              </el-button>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item
          label="金额"
          prop="amount"
          :rules="[{ required: true, message: '请输入金额', trigger: 'blur' }]"
        >
          <el-input-number
            v-model="state.model.amount"
            precision="2"
            class="number-input-left number-input-suffix !w-full"
            suffix="元"
          ></el-input-number>
        </el-form-item>
      </ul>
      <el-form-item
        label="名称"
        prop="name"
        :rules="[{ required: true, message: '请输入名称', trigger: 'blur' }]"
      >
        <el-input v-model="state.model.name"></el-input>
      </el-form-item>
      <el-form-item label="款项说明">
        <el-input v-model="state.model.intro" type="textarea"></el-input>
      </el-form-item>
      <el-form-item
        label="附件"
        prop="files"
        :rules="[{ required: true, message: '请上传附件', trigger: 'blur' }]"
      >
        <c_UploadFile
          :key="state.model.id"
          :value="state.model.files"
          @change="
            (data) => {
              state.model.files = data;
            }
          "
        />
      </el-form-item>
    </el-form>
    <div class="submit-box px-2.5">
      <el-button type="primary" size="large" @click="onSubmit">
        提交
      </el-button>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  meeting_collected_plan_detail,
  meeting_collected_plan_add,
  meeting_collected_plan_edit,
} from "@/http/meeting";
import { data_getCustomer } from "@/http/data";
import { attachment_upload } from "@/http/attachment";
import { post_response } from "@/utils/funcs";

export default {
  props: {
    meeting_id: Number,
    id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {
        files: [],
      },
    });
    onMounted(() => {
      state.model.meeting_id = props.meeting_id;
      onLoadJfdw();
      if (props.id) {
        meeting_collected_plan_detail(props.id).then((res) => {
          if (res.status == 200) {
            const { data } = res.data;
            state.model = data;
            state.model.files = data.attachment;
          }
        });
      }
    });

    //获取甲方单位
    const onLoadJfdw = () => {
      data_getCustomer().then((res) => {
        if (res.status == 200) state.jfdw_data = res.data?.data?.list || [];
      });
    };

    const onFileChange = (file) => {
      const formData = new FormData();
      formData.append("file[]", file.raw);
      attachment_upload(formData).then((res) => {
        if (res.status == 200) {
          state.model.files = [...state.model.files, ...res.data.data];
        }
      });
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          state.model.attachment = JSON.stringify(
            state.model.files?.map((m) => m.id),
          );

          if (props.id) {
            meeting_collected_plan_edit(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          } else {
            meeting_collected_plan_add(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          }
        }
      });
    };

    return {
      state,
      props,
      formDom,
      onSubmit,
      onLoadJfdw,
      onFileChange,
    };
  },
};
</script>
<style scoped></style>
